import React, { FC } from 'react';
import { PercentageWidget } from './percentage-widget';
import { WidgetState } from './state';

interface Props<T, E> {
  value: WidgetState<T, E>;
}
export const TasksCompleted: FC<Props<number, unknown>> = ({ value }) => (
  <PercentageWidget value={value} widgetKey="tasks_completed_on_time" />
);
